import { GetFunction, LoginV1 } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: localStorage.getItem('access_token') || getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    },
    userInfo: {}
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.userInfo = info
    }
  },

  actions: {
    // 用户名登录50007
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        LoginV1({
          user_name: username,
          login_id: username,
          login_pwd: userInfo.password,
          request_id: userInfo.request_id,
          datas: userInfo.datas,
          supplier_flag: '2'
        }).then(response => {
          if (response.data.res_status_code == 0) {
            commit('SET_TOKEN', response.data.res_content.token)
            commit('SET_INFO', response.data.res_content)
            setToken(response.data.res_content.token)
            // setInfo(response.data.res_content)
            resolve(response)
          } else if (response.data.res_status_code == '50007') {
            resolve(response)
          } else {
            if (response.data.res_status_code != '50050') {
              Message({
                message: response.data.res_message,
                type: 'error'
              })
            }
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }, iframeData = {}) {
      const token = Object.keys(iframeData).length > 0 ? iframeData.token : state.token
      const oidcStatus = process.env.NODE_ENV === 'development'
      const isNeedToken = oidcStatus || Object.keys(iframeData).length > 0
      return new Promise((resolve, reject) => {
        GetFunction(isNeedToken ? token : null).then(response => {
          const data = response.data.res_content
          const roles = []
          for (var i = 0; i < response.data.res_content.roles.length; i++) {
            roles.push(response.data.res_content.roles[i].role_code)
          }
          if (roles && roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          window.localStorage.setItem('router', JSON.stringify(data.functions))
          commit('SET_NAME', data.user_name)
          commit('SET_INFO', data)
          commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_INFO', {})
        removeToken()
        resolve()
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_INFO', {})
        removeToken()
        resolve()
      })
    }
  }
}

export default user
